import {
  call, put, takeEvery, all, select,
} from 'redux-saga/effects';
import { actions } from 'react-redux-form/immutable';
import { addErrorMessage, addSuccessMessage } from './messages/messageActions';
import { history } from '../history';
import { getStored, redirectLoginAndWait } from '../sessionMonster';

const getToken = state => state.get('loginPage').get('apiToken');

let currentToken = '';

export const createApiSaga = ({
  apiFunction,
  generateApiConfig,
  requestType,
  successType,
  failureType,
  successActionCreators,
  dataPostProcessors,
  preActionCreators,
  successMessage,
  silentFlashErrors,
}) => {
  function* handler(action) {
    const {
      location, formModel, goBack,
    } = action;


    try {
      let retry = true;
      let apiResponse;
      while (retry) {
        const apiToken = yield select(getToken);
        if (preActionCreators) {
          const puts = [];
          const ctx = {
            action,
            apiToken,
          };
          preActionCreators.forEach(actionCreator => puts.push(put(actionCreator(ctx))));
          yield all(puts);
        }

        try {
          apiResponse = yield call(apiFunction, generateApiConfig({ ...action, apiToken }));
          retry = false;
        } catch (error) {
          let statusCode;
          const { responseContext } = error;
          if (responseContext) {
            const { response } = responseContext;
            if (response) {
              const { status } = response;
              statusCode = status;
            }
          }
          if (statusCode && (statusCode === 401 || statusCode === 403)) {
            if (currentToken) {
              yield call(redirectLoginAndWait, false, currentToken);
            } else {
              currentToken = getStored();
              yield call(redirectLoginAndWait, true, currentToken);
            }
          } else {
            throw error;
          }
        } finally {
          currentToken = '';
        }
      }

      const { response: { data } } = apiResponse;
      let processedData = data;
      if (dataPostProcessors) {
        dataPostProcessors.forEach((processor) => { processedData = processor(processedData); });
      }
      const puts = [];
      if (successActionCreators) {
        const sacContext = {
          action,
          response: processedData,
        };
        successActionCreators.forEach(actionCreator => puts.push(put(actionCreator(sacContext))));
      }
      puts.push(put({ type: successType, response: processedData }));
      if (successMessage) {
        puts.push(put(addSuccessMessage(successMessage)));
      }
      if (location) {
        puts.push(call(history.push, location));
      } else if (goBack) {
        puts.push(call(history.goBack));
      }

      yield all(puts);
    } catch (error) {
      let errorData;
      const { responseContext } = error;
      if (responseContext) {
        const { response } = responseContext;
        if (response) {
          const { data } = response;
          if (data) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            errorData = data;
          }
        }
      }

      if (!errorData || !errorData.flashErrors) {
        // The request was made but no response was received
        errorData = {
          flashErrors: [
            'An Unknown Error Occurred',
          ],
          formErrors: {},
        };
      }

      const puts = [];

      if (errorData.formErrors && formModel) {
        Object.entries(errorData.formErrors).forEach(([field, errors]) => puts.push(put(actions.setErrors(`${formModel}.${field}`, errors))));
      }

      puts.push(put({ type: failureType, response: errorData }));

      if (!silentFlashErrors) {
        errorData.flashErrors.forEach(message => puts.push(put(addErrorMessage(message))));
      }

      yield all(puts);
    }
  }

  function* watcher() {
    yield takeEvery(requestType, handler);
  }

  return watcher;
};
